"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("../http");
const getContactDuplicate = async ({ axios, ico, dic }) => {
    const { data } = await http_1.httpGet({
        axios,
        url: "contacts/duplicate",
        params: {
            ico,
            dic
        }
    });
    return data;
};
exports.default = getContactDuplicate;
